import React from "react";
import { withI18n } from "react-i18next";
import { client } from "../../../shared/apiClient";
import UserAvatar from "../../../images/useravatar.png";

const PlaceholderImgSection = (props: {
  t: any;
  isReadOnly: boolean;
  clientId?: number;
  fn?: string;
}) => {
  const { t, isReadOnly, clientId, fn } = props;

  const imgSrc =
    !isReadOnly && clientId && fn
      ? `${client.api.paths.imageDomain}/getImg?ct=${clientId}&fn=${fn}&i=1&thj=h` // TODO: loaded img has odd size
      : UserAvatar;

  const imgStyle =
    !isReadOnly && clientId && fn
      ? {}
      : { background: "#f9f8f8", width: "250px" };

  return (
    // TODO: remove this temp style
    <section className="float-right" style={{ marginTop: "-30px" }}>
      <img
        placeholder={t("This is a placeholder")}
        src={imgSrc}
        alt={t("Img not found")}
        height={300} // TODO: review this
        style={imgStyle}
      />
    </section>
  );
};

export default withI18n()(PlaceholderImgSection);
